export default {
  title: 'Lieferanbieter',
};
